import format from "date-fns/format";
import { vocFrequency, vocThemes, vocCategories } from "@/constants";

export const getMetadataInfo = (datasets, dataset) => {
  return new Promise((resolve, reject) => {
    const currentDataset = datasets.find(
      row => row.url_path === dataset.replace("/", "")
    );

    const metadata = currentDataset ? currentDataset.metadata : [];

    const rows = Object.entries(metadata).map(row => {
      if (
        row[1] === null ||
        (Array.isArray(row[1]) && row[1].length == 0) ||
        (typeof row[1] === "object" &&
          row[1]["name"] === null &&
          row[1]["email"] === null)
      ) {
        return false;
      }
    });

    if (!rows.every(row => row === false)) {
      return resolve(metadata);
    } else {
      return reject(new Error("No metadatta"));
    }
  });
};

export const prepareRows = (vue, row) => {
  if (
    row[1] === null ||
    (Array.isArray(row[1]) && row[1].length == 0) ||
    (typeof row[1] === "object" &&
      row[1]["name"] === null &&
      row[1]["email"] === null)
  ) {
    return false;
  }

  if (row[0] === "documentationReference" || row[0] === "description") {
    return false;
  }
  if (row[0] === "dataPeriodAffected") {
    return [
      vue.$t(`dataset.meta.${row[0]}`),
      `${format(new Date(row[1][0]), "DD.MM.YYYY")} - ${format(
        new Date(row[1][1]),
        "DD.MM.YYYY"
      )}`
    ];
  }

  if (row[0] === "administrator" || row[0] === "author") {
    const nameWithEmail = `<a href="mailto:${row[1]["email"]}">${
      row[1]["name"]
    }</a>`;
    const onlyEmail = `<a href="mailto:${row[1]["email"]}">${
      row[1]["email"]
    }</a>`;
    const onlyName = row[1]["name"];

    let content = "";
    if (row[1]["email"] === "" || row[1]["email"] === null) {
      content = onlyName;
    } else if (row[1]["name"] === "" || row[1]["name"] === null) {
      content = onlyEmail;
    } else {
      content = nameWithEmail;
    }

    return [vue.$t(`dataset.meta.${row[0]}`), content];
  }

  if (row[0] === "keywords") {
    return [vue.$t(`dataset.meta.${row[0]}`), `${row[1].join(", ")}`];
  }

  if (row[0] === "datasetTopic") {
    const topic = vocThemes.find(theme => theme.id == row[1]);

    return [
      vue.$t(`dataset.meta.${row[0]}`),
      vue.$t(`dataset.meta.vocThemes.${topic.key}`)
    ];
  }

  if (row[0] === "updateFrequency") {
    const frequency = vocFrequency.find(flequency => flequency.id == row[1]);

    return [
      vue.$t(`dataset.meta.${row[0]}`),
      vue.$t(`dataset.meta.vocFrequency.${frequency.key}`)
    ];
  }

  if (row[0] === "euroVocClassification") {
    const categories = row[1].map(category => {
      const categoryTranslation = vocCategories.find(cat => cat.id == category);

      return vue.$t(`dataset.meta.vocCategories.${categoryTranslation.key}`);
    });

    return [vue.$t(`dataset.meta.${row[0]}`), categories.join(", ")];
  }

  return [vue.$t(`dataset.meta.${row[0]}`), row[1]];
};
